import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/app/hooks";
import { selectBoardState } from "@/features/bughurd/boardSelector";
import DeleteConfirmModal from "@/Components/Common/DeleteConfirmModal";

interface BoardModalsProps {
  onDeleteConfirm: () => void;
  onDeleteCancel: () => void;
  isDeletingStatus: boolean;
}

const BoardModals: React.FC<BoardModalsProps> = ({
  onDeleteConfirm,
  onDeleteCancel,
  isDeletingStatus,
}) => {
  const { t } = useTranslation(["bugherd"]);
  const boardState = useAppSelector(selectBoardState);
  const { isDragging, isDeleteConfirmOpen, columnToDelete } = boardState;

  return (
    <>
      {/* Delete Confirmation Modal */}
      {isDeleteConfirmOpen && (
        <DeleteConfirmModal
          open={isDeleteConfirmOpen}
          onClose={onDeleteCancel}
          onConfirm={onDeleteConfirm}
          confirmMessage={`${t(
            "Are you sure you want to delete the column"
          )} "${columnToDelete?.title}"?`}
          loading={isDeletingStatus}
          title={t("Delete Column")}
          okText={t("Delete")}
        />
      )}

      {/* Drag Overlay */}
      {isDragging && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            pointerEvents: "none",
          }}
        />
      )}
    </>
  );
};

export default BoardModals;
